<template>
  <v-row
      v-if="errorText"
      align="start"
      justify="center"
      class="d-flex align-self-start"
  >
    <v-col align="center">{{ errorText }}</v-col>
  </v-row>
  <v-row
      v-if="errorText"
      align="start"
      justify="center"
  >
    <v-btn
        color="primary"
        class="mt-4 text-white"
        :text="$t('Вернуться к процедурам')"
        @click="redirectToProcedures()"
    />

  </v-row>
</template>

<script>

export default {
  name: 'ErrorException',
  props: {
    errorText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    async redirectToProcedures() {
      this.$router.push({path: '/procedures'});
    },
  },
};
</script>

<style scoped>

</style>